/**
 * @generated SignedSource<<eadb274e73fd08ca31dbf4ea19cbc2b2>>
 * @relayHash 4f8af1f11160c2a680a2192660d8ca13
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/578.0.0-2026-09-17T08:13:42.063Z/emailLoginMutation

import { ConcreteRequest } from 'relay-runtime';
export type SupportedMFATypes = "CODE" | "%future added value";
export type UserEmailLoginInput = {
  captchaKey?: string | null;
  captchaRequestUuid?: string | null;
  captchaToken?: string | null;
  clientMutationId?: string | null;
  cookieDomain: string;
  emailLoginToken: string;
  mfaVerificationCode?: string | null;
  supportedMFATypes?: ReadonlyArray<SupportedMFATypes | null> | null;
};
export type emailLoginMutation$variables = {
  input: UserEmailLoginInput;
};
export type emailLoginMutation$data = {
  readonly userEmailLogin: {
    readonly clientMutationId: string | null;
    readonly error: {
      readonly message: string | null;
    } | null;
  } | null;
};
export type emailLoginMutation = {
  response: emailLoginMutation$data;
  variables: emailLoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserEmailLoginPayload",
    "kind": "LinkedField",
    "name": "userEmailLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEmailLoginError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "emailLoginMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "emailLoginMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ferrum/578.0.0-2026-09-17T08:13:42.063Z/emailLoginMutation",
    "metadata": {},
    "name": "emailLoginMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "51ca94a6b02a0208b2251240205c59cf";

export default node;
